export default {
  required: "{0}を入力してください。",
  requiredNumber: "{0}を入力してください。",
  maxLength: "{0}は{1}文字以内で入力してください。",
  duplicateItem: "{0}が既存しました。",
  onlyNumber: "{0}項目に整数を入力してください。",
  totalShouldMore: "{0}項目が{1}{2}以下にしてください",
  errorFormat: "{0}の入力形式が正しくありません。",
  noDataAvailable:
    "検索条件に該当するデータが見つかりません。検索条件を見直してください。",
  noData: "データなし",
  loadingData: "データを読み込み中、少々お待ちください...",
  sessionExpired:
    "セクションがタイムアウトしました。再度ログインしてください。",
  errorSystem: "システムエラーが発生しました。もう一度確認してください。",
  inputExcludedHtml:
    "この項目にHTMLコード及びスクリプトコードを入力しないでください。",
  valueInputBetween: "{0}項目に{1}から{2}まで数を入力してください。",
  noInternet:
    "サーバへ接続ができません。インターネット接続を確認してください。",
  fileSize: "{0}は{1}MB以下のファイルを選択してください。",
  fileTypes: "{0}は{1}のファイルを選択してください。",
  save: "保存",
  cancel: "キャンセル",
  updateSuccess: "更新しました",
  updateFail: "更新失敗",
  submitSuccess: "申請しました",
  submitFail: "申請失敗しました",
  rejectSuccess: "取り戻しました",
  rejectFail: "取り戻し失敗",
  rollbackTargetFail: "承認が取り消しできません。",
  rollbackTargetSuccess: "承認を取り消しました。",
  approveSuccess: "承認済み",
  approveFail: "承認失敗",
  require: "必須",
  valueMustLessThan: " {0}文字以下入力してください",
  totalMustEqual: " {0}文字を入力してください",
  notBlank: "必須",
  maxChar: "{0}文字以内で入力してください。",
  mustNumPositive: "0より大きい数字で入力してください。",
  duplicateTargetName: "評価項目名が重複しています。",
  dupDetailName: "評価項目名が重複しています。",
  saveSuccess: "登録完了",
  confirmDeleteCpTable:
    "評価テーブルを削除すると、紐づけている被評価者等の設定した情報も削除されます。",
  requirePositiveNumber: "{0}項目に負の数を入力しないでください。",
  memberSettingTransfer: "人事異動設定",
  moveSetting: "移動設定",
  uploadSuccessfully: "アップロード完了",
  uploadFail: "アップロード失敗",
  beingDownloaded: "ファイルをダウンロードしています",
  downloadFail: "ダウンロード失敗",
  deleteSuccessfully: "削除完了",
  deleteFail: "削除失敗",
  invalidTargetSettings:
    "評価テーブル名が既に存在しているので、保存できません。",
  rejectEvaluationMember:
    "評価項目に評価確定されたメンバーがいるので、取り消すことができません。",
  invalidInputValue: "入力値が不正です。",
  invalidInputEvaluation: "評価項目の入力に誤りがあります。",
  removeSuccess: "メンバーを削除しました。",
  removeFail: "メンバー削除が失敗しました。",
  transferMemberIsOver:
    "分割期間の上限に達しました。メンバー異動が出来ません。",
  transferMemberIsOverCode: "MSG_PERIODS_IS_OVER",
  notLinked2ExistingEvaluation:
    "既存の評価テータと紐づけない。よろしいですか。",
};
